"use strict";
exports.__esModule = true;
exports.asTimestamp = void 0;
function asTimestamp(date) {
    return date.getTime() / 1000;
}
exports.asTimestamp = asTimestamp;
//# sourceMappingURL=typeUtils.js.map